import React, { useState } from "react";
import { Phone, Mail, Menu, X, LogIn, LayoutDashboard } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { companyInfo } from "../mock";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const [open, setOpen] = useState(false);
  const { user, login } = useAuth();
  const navigate = useNavigate();

  const navLinks = [
    { label: "HOME", href: "/#home" },
    { label: "About", href: "/#about" },
    { label: "Services", href: "/#services" },
    { label: "Contact", href: "/#contact" },
  ];

  return (
    <header className="w-full sticky top-0 z-50 shadow-sm">
      {/* Top red bar */}
      <div className="bg-brand-red text-white">
        <div className="max-w-7xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-8 text-sm">
          <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 hover:opacity-90">
            <Phone size={16} />
            <span>{companyInfo.phone}</span>
          </a>
          <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:opacity-90">
            <Mail size={16} />
            <span>{companyInfo.email}</span>
          </a>
        </div>
      </div>

      {/* Main nav */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <Logo />
            <div className="leading-tight hidden sm:block">
              <div className="font-display text-lg font-bold text-[color:var(--brand-teal)]">ERM</div>
              <div className="text-[10px] tracking-[0.2em] text-gray-500 -mt-1">CARGO & PACKAGING L.L.C.</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="font-display uppercase text-sm text-gray-800 hover:text-[color:var(--brand-red)] tracking-wider transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            {user ? (
              <button
                onClick={() => navigate("/dashboard")}
                className="inline-flex items-center gap-2 font-display uppercase text-sm tracking-wider px-4 py-2 rounded border-2 border-[color:var(--brand-teal)] text-[color:var(--brand-teal)] hover:bg-[color:var(--brand-teal)] hover:text-white transition-colors"
              >
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="w-6 h-6 rounded-full object-cover" />
                ) : (
                  <LayoutDashboard size={16} />
                )}
                <span>My Account</span>
              </button>
            ) : (
              <button
                onClick={login}
                className="inline-flex items-center gap-2 btn-red font-display uppercase text-sm tracking-wider px-4 py-2 rounded"
              >
                <LogIn size={16} /> Sign In
              </button>
            )}
          </div>

          <button
            className="md:hidden text-gray-800"
            onClick={() => setOpen(!open)}
            aria-label="toggle menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-gray-100 bg-white">
            <div className="px-4 py-3 flex flex-col gap-3">
              {navLinks.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-display uppercase text-sm text-gray-800 hover:text-[color:var(--brand-red)] tracking-wider"
                >
                  {l.label}
                </a>
              ))}
              {user ? (
                <button
                  onClick={() => { setOpen(false); navigate("/dashboard"); }}
                  className="font-display uppercase text-sm text-[color:var(--brand-teal)] tracking-wider text-left"
                >
                  My Account
                </button>
              ) : (
                <button
                  onClick={() => { setOpen(false); login(); }}
                  className="font-display uppercase text-sm text-[color:var(--brand-red)] tracking-wider text-left"
                >
                  Sign In
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_relocate-easy-18/artifacts/7yo2uqgh_Black%20and%20White%20Simple%20Letter%20B%20Logo.png";

const Logo = () => (
  <img
    src={LOGO_URL}
    alt="ERM Cargo & Packaging LLC logo"
    data-testid="header-logo"
    className="w-12 h-12 rounded-full object-contain"
  />
);

export default Header;
